import type { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

function base(props: IconProps) {
  return {
    width: '1em',
    height: '1em',
    viewBox: '0 0 20 20',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.6,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
    ...props,
  }
}

export function IconChat(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M3.5 5.75c0-1.24 1.01-2.25 2.25-2.25h8.5c1.24 0 2.25 1.01 2.25 2.25v6c0 1.24-1.01 2.25-2.25 2.25H8.5L5 16.75V14H5.75c-1.24 0-2.25-1.01-2.25-2.25z" />
    </svg>
  )
}

export function IconDocument(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M6 3.5h5.5L16 8v8.25a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75V4.25c0-.41.34-.75.75-.75Z" />
      <path d="M11.25 3.5V8H16" />
      <path d="M7.5 11h5M7.5 13.5h5" />
    </svg>
  )
}

export function IconLogout(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M8.5 16.5h-3a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h3" />
      <path d="M13 13.5 16.5 10 13 6.5" />
      <path d="M16.25 10h-8.5" />
    </svg>
  )
}

export function IconPlus(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M10 4v12M4 10h12" />
    </svg>
  )
}

export function IconTrash(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M4.25 6h11.5" />
      <path d="M8 6V4.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1V6" />
      <path d="M6 6v9a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6" />
      <path d="M8.5 9v4M11.5 9v4" />
    </svg>
  )
}

export function IconCheck(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M4 10.5 8 14.5 16 6" />
    </svg>
  )
}

export function IconX(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M5 5l10 10M15 5 5 15" />
    </svg>
  )
}

export function IconChevronRight(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M7.5 4.5 13 10l-5.5 5.5" />
    </svg>
  )
}

export function IconChevronLeft(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12.5 15.5 7 10l5.5-5.5" />
    </svg>
  )
}

export function IconChevronDown(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M4.5 8 10 13.5 15.5 8" />
    </svg>
  )
}

export function IconSend(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M16.5 3.5 3.5 9.25l5.25 1.75M16.5 3.5 10.5 16.5l-1.75-5.5M16.5 3.5 9 11" />
    </svg>
  )
}

export function IconLink(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M8.5 11.5a3 3 0 0 0 4.24.16l2-2a3 3 0 0 0-4.24-4.24l-1.1 1.09" />
      <path d="M11.5 8.5a3 3 0 0 0-4.24-.16l-2 2a3 3 0 0 0 4.24 4.24l1.09-1.1" />
    </svg>
  )
}

export function IconInbox(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M3.5 11 5.75 4.75A1 1 0 0 1 6.69 4.1h6.62c.42 0 .8.27.94.66L16.5 11" />
      <path d="M3.5 11h4l.75 1.75h3.5L12.5 11h4v3.75c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25Z" />
    </svg>
  )
}

export function IconSettings(props: IconProps) {
  return (
    <svg {...base(props)}>
      <circle cx="10" cy="10" r="2.25" />
      <path d="M10 3.25v1.5M10 15.25v1.5M3.25 10h1.5M15.25 10h1.5M5.2 5.2l1.06 1.06M13.74 13.74l1.06 1.06M5.2 14.8l1.06-1.06M13.74 6.26l1.06-1.06" />
    </svg>
  )
}

export function IconPencil(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12.5 4.5 15.5 7.5 8 15H5v-3z" />
      <path d="M11 6l3 3" />
    </svg>
  )
}

export function IconCopy(props: IconProps) {
  return (
    <svg {...base(props)}>
      <rect x="7" y="7" width="8.5" height="9" rx="1.25" />
      <path d="M5.5 13V5.25A1.25 1.25 0 0 1 6.75 4H12.5" />
    </svg>
  )
}

export function IconThumbsUp(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M7.5 9V16h6.4c.86 0 1.6-.6 1.78-1.44l.85-4A1.82 1.82 0 0 0 14.75 8.4H11.5l.5-3.1a1.35 1.35 0 0 0-2.55-.66L7.5 9Z" />
      <path d="M4.5 9h2v7h-2z" />
    </svg>
  )
}

export function IconThumbsDown(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12.5 11V4H6.1c-.86 0-1.6.6-1.78 1.44l-.85 4A1.82 1.82 0 0 0 5.25 11.6h3.25l-.5 3.1a1.35 1.35 0 0 0 2.55.66L12.5 11Z" />
      <path d="M15.5 11h-2V4h2z" />
    </svg>
  )
}
